import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Sections from "../components/sections"
import Protect from "../components/protect"


const PageTemplate = ({ location, data: { page } }) => {
  const customSections = page?.customSections
  const hasPassword = page?.hasPassword
  return (
    <Layout isHomePage={page.uri === '/'} uri={page.uri} location={location} pageOptions={page?.pageOptions}>
      <Seo
        title={page.seo?.title || page.title}
        description={page.seo?.metaDesc}
        image={page.seo?.opengraphImage?.localFile?.publicURL}
        uri={page.uri}
        robots={page.uri.startsWith("/private/") || hasPassword ? 'noindex, nofollow' : undefined}
      />

      {customSections?.sections && (
        <>
          {hasPassword ? (
            <Protect>
              <Sections props={customSections} location={location} />
            </Protect>
          ) :
            <Sections props={customSections} location={location} />
          }
        </>
      )}
    </Layout>
  )
}

export default PageTemplate

export const pageQuery = graphql`
  query WordPressPage($id: String!) {
    page: wpPage(id: { eq: $id }) {
      title
      uri
      hasPassword
      seo {
        title
        metaDesc
        opengraphImage {
          localFile {
            publicURL
          }
        }
      }
      pageOptions {
        displayCasinoAlert
        hideSubscribeForm
      }
      customSections {
        sections {
          ... on WpPage_Customsections_Sections_Banner {
            background
            hideOnMobile
            content
            fieldGroupName
            heading
            subheading
            breadcrumb {
              target
              title
              url
            }
            image {
              altText
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(width: 2560)
                }
              }
            }
            video {
              mediaItemUrl
              title
            }
            videoEmbed
            videoTitle
            videoOptions {
              videoSource
            }
            cta {
              target
              title
              url
            }
            secondaryCta {
              target
              title
              url
            }
            blocks {
              image {
                altText
                localFile {
                  publicURL
                  extension
                  childImageSharp {
                    gatsbyImageData(width: 1024)
                  }
                }  
                mediaDetails {
                  sizes {
                    sourceUrl
                  }
                } 
              }
              heading
              content
              cta: link {
                target
                title
                url
              }
            }
            imageOptions {
              imageFocus
            }
            ctaFormat
          }
          ... on WpPage_Customsections_Sections_Content {
            fieldGroupName
            heading
            content
            cta {
              target
              title
              url
            }
            ...Blocks
            alignment
            contentWidth
            backgroundColor
            blocksFormat
            collapseContentOnMobile
            collapseBlocksContentOnMobile
            isPromotions
          }
          ... on WpPage_Customsections_Sections_Gallery {
            fieldGroupName
            heading
            description
            images {
              altText
              caption
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(width: 512)
                  original {
                    height
                    src
                    width
                  }
                }
              }
            }
          }
          ... on WpPage_Customsections_Sections_Accordions {
            fieldGroupName
            heading
            content
            accordions {
              panel
              button
            }
          }
          ... on WpPage_Customsections_Sections_FeaturedItems {
            fieldGroupName
            type
            heading
            content
            cta {
              target
              title
              url
            }
            image {
              altText
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(width: 1444)
                }
              }
            }
            diningList {
              ... on WpDining {
                ...DiningCard
              }
            }
            diningListOptions {
              format
            }
            featuredDiningOption {
              ... on WpDining {
                title
                uri
                excerpt
                dining {
                  logo {
                    altText
                    localFile {
                      publicURL
                      extension
                      childImageSharp {
                        gatsbyImageData(width: 1444)
                      }
                    }
                  }
                  card {
                    buttonTitle
                  }
                  hours {
                    hoursDetails {
                      days
                      hours
                    }
                  }
                }
                featuredImage {
                  node {
                    altText
                    localFile {
                      publicURL
                      extension
                      childImageSharp {
                        gatsbyImageData(width: 1444)
                      }
                    }
                  }
                }
              }
            }
          }
          ... on WpPage_Customsections_Sections_SearchList {
            fieldGroupName
            heading
            searchPlaceholder
            successMessage
            listItems
          }
          ... on WpPage_Customsections_Sections_Form {
            fieldGroupName
            formType
          }
          ... on WpPage_Customsections_Sections_Profile {
            content
            fieldGroupName
            heading
            image {
              altText
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(width: 1444)
                }
              }
            }
          }
          ... on WpPage_Customsections_Sections_Table {
            fieldGroupName
            heading
            columnHeadings {
              columnHeading
              columnSubheading
              columnColor
              columnImage {
                altText
                localFile {
                  publicURL
                  extension
                  childImageSharp {
                    gatsbyImageData(width: 512)
                  }
                }
              }
            }
            rows {
              rowHeading
              rowType
              rowValues {
                isChecked
                text
                subtext
              }
            }
          }
        }
      }
    }
  }
`
